import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { DeleteFilled, EditFilled, EyeFilled,CheckCircleFilled,CloseCircleFilled,MinusCircleFilled } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { message, Spin,Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { ClientApi } from "../../api/clientApi";
import Swal from "sweetalert2";

const ListClientView = () => {
    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [clients, setClients] = useState([])
    const [loading, setLoading] = useState(false)
    // const [totalPages,] = useState(1)
    const itemsPerPage = 15
    const [currentPage, setCurrentPage] = useState(1)

    
    const navigate = useNavigate()


    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await ClientApi.getClients(abortController.signal)
 
            if(!res){
                setLoading(false)
                   return;

            }            
            
            setClients(res.data)
            setLoading(false)
            console.log(clients)
 
         } catch (error) {
             console.log(error)
            setLoading(false)
            const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                Auth.removeSessionToken()
                return navigate(`/login`)			
              });
 
         }
    }

    const handleDetail = (client) => {
        console.log("ID mecano",client.id)
        if(client.id)
            return navigate(`/gestion-clients/${client.id}/details`)
        
    }


    const handleEdit =(client) => {
      if(client.id)
        return navigate(`/gestion-clients/${client.id}/edit`)
    }
    const handleDelete = async (client) => {
        try {
          const res = await ClientApi.deleteClient(`${client.id}`,abortController.signal)

          if (res) {
            message.success("Les informations ont été mises à jour avec succès !");
          }

          handlefetchdata()
          
        } catch (error) {
          console.error(error);
          setLoading(false);
          message.error("Échec de suppression des informations");
        }
        
    }
    const handleEnable = async (provider) =>{
          try {
            const res = await ClientApi.enable(`${provider.user_id}`,abortController.signal)
            if (res.success == true) {
              message.success("Compte activé avec succès");
            }else{
              message.error(res.message);
    
            }
    
            handlefetchdata()
          } catch (error) {
            console.error(error);
              setLoading(false);
              message.error("Échec d'activation des informations");
          }
    }
    
    const handleDisable = async (provider) =>{
      try {
        const res = await ClientApi.disable(`${provider.user_id}`,abortController.signal)
        if (res.success == true) {
          message.success("Compte desactivé avec succès");
        }else{
          message.error(res.message);

        }

        handlefetchdata()
      } catch (error) {
        console.error(error);
          setLoading(false);
          message.error("Échec d'activation des informations");
      }
    }

    const handleBanish = async (provider) =>{
      try {
        const res = await ClientApi.banish(`${provider.user_id}`,abortController.signal)
        if (res.success == true) {
          message.success("Compte bani avec succès");
        }else{
          message.error(res.message);

        }

        handlefetchdata()
      } catch (error) {
        console.error(error);
          setLoading(false);
          message.error("Échec d'activation des informations");
      }
    }

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = clients.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    

    useEffect(() => {
        handlefetchdata()

        console.log('liste client',clients)
    },[])

  return (
    <MainLayout>
      <div className="container mx-auto p-4">
        <h1 className="text-xl font-bold mb-4">Liste des clients</h1>

        {/* Bouton Ajouter */}
        

        {/* Table */}
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-2 px-4 border-b text-left">#</th>
              <th className="py-2 px-4 border-b text-left">Nom et prenoms</th>
              <th className="py-2 px-4 border-b text-left">Contact</th>
              <th className="py-2 px-4 border-b text-left">adresse</th>
              <th className="py-2 px-4 border-b text-left">Etat du compte</th>
              <th className="py-2 px-4 border-b text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="text-sm text-center py-4">
                    Chargement des données en cours...
                </td>
                </tr>
            ) : (
              currentItems.map((client, index) => (
                <tr key={client.id}>
                    <td className="py-2 px-4 border-b">{index + 1}</td>
                    <td className="py-2 px-4 border-b">
                    {client?.name} {client?.lastname}
                    </td>
                    <td className="py-2 px-4 border-b">{client?.contact}</td>
                    <td className="py-2 px-4 border-b">{client?.adresse}</td>
                    <td className="py-2 px-4 border-b">
                      {/* {client?.user} */}
                      {!client?.user?.is_banned && !client?.user?.is_active && client?.user?.deleted_at === null ? (

                        <>
                          <span className="text-red-200 bg-red-700 p-2 text-sm rounded-md">Compte desactivé</span>
                        </>
                      ) : client?.user?.is_banned === 0 && client?.user?.is_active === 1 && client?.user?.deleted_at === null ? (
                        <>
                          <span className="text-green-200 bg-green-700 p-2 text-sm rounded-md">Compte actif</span>
                        </>
                      ) : (
                        <>
                          <span className="text-red-200 bg-red-700 p-2 text-sm rounded-md">Compte supprimé</span>
                        </>
                      
                      )}

                     
                    </td>
                    <td className="py-2 px-4 border-b">
                    <EyeFilled
                        className="text-green-600 mr-2 cursor-pointer hover:text-green-800"
                        onClick={() => handleDetail(client)}
                    />
                    <EditFilled className="text-blue-600 mr-2 cursor-pointer hover:text-blue-800" 
                      onClick={() => handleEdit(client) }

                    />
                    <DeleteFilled className="text-red-600 cursor-pointer hover:text-red-800"
                      onClick={() => handleDelete(client)}
                    />
                    {
                      client?.user?.is_active === 0 && 
                      <Tooltip title="Activer ce compte">
                        <CheckCircleFilled  className="ml-2 cursor-pointer text-green-800" onClick={() => handleEnable(client)} />
                      </Tooltip>
                    }
                    
                    {
                      client?.user?.is_active === 1 &&
                      <Tooltip title="Desactiver ce compte">
                        <CloseCircleFilled className="ml-2 cursor-pointer text-red-800" onClick={() => handleDisable(client)}/>
                      </Tooltip>
                    }
                    
                    {
                      client?.user?.is_banned === 0 &&
                      <Tooltip title="Banir ce compte">

                        <MinusCircleFilled className="ml-2 cursor-pointer text-red-800" onClick={() => handleBanish(client)}/>
                      </Tooltip>
                    }
                    </td>
                </tr>
                ))
            )}
            </tbody>

        </table>
        <div className="flex ml-0 space-x-2 mt-2 justify-end">
            {Array.from({ length: Math.ceil(clients.length / itemsPerPage) }, (_, i) => (
                <button 
                    key={i} 
                    onClick={() => paginate(i + 1)}
                    className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                >
                    {i + 1}
                </button>
            ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default ListClientView;
